import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { RbacRoleEntity } from './rbac-role.entity';

/**
 * Subtractive permission override for a child role (PD-15546).
 *
 * A row here means "role X does NOT get action Y, even though its parent
 * role grants it". Exclusions live in their own table rather than as a
 * flag on `_rbac_action__role` so that any reader of the grant table that
 * is not exclusion-aware fails CLOSED (it simply never sees the row) instead
 * of mistaking a denial for a grant.
 *
 * An exclusion is inert while the parent does not hold the action, which
 * lets a child role pre-declare "never this" for actions the parent may be
 * granted later.
 */
@Index('uq_rbac_role_action_exclusion', ['fkRbacRoleId', 'action'], {
	unique: true,
})
@Index('idx_rbac_role_action_exclusion_role', ['fkRbacRoleId'])
@Entity('rbac_role_action_exclusion')
export class RbacRoleActionExclusionEntity extends BaseEntity {
	@Column('int', { name: 'fk__rbac_role__id', unsigned: true })
	public fkRbacRoleId!: number;

	@Column('varchar', { name: 'action', length: 255 })
	public action!: string;

	@ManyToOne(() => RbacRoleEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk__rbac_role__id', referencedColumnName: 'id' }])
	public fkRbacRole!: RbacRoleEntity;
}
